import React, { useContext, useState, useEffect } from 'react';
import styles from './styles.module.css';
import Text from 'components/shared/Text';
import MobileContext from 'context/MobileContext';
import {
  AppBar,
  Box,
  Dialog,
  Fade,
  Modal,
  LinearProgress,
  makeStyles,
  Toolbar,
  Typography,
} from '@material-ui/core';
import { isEmpty } from 'lodash';
import {
  closeIcon,
  checkmarkCircleOutline,
  imgVisa,
  imgMastercard,
  imgDiscover,
  imgAmex,
} from 'assets/newIcons';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Button from 'components/shared/Button';
import { CircularProgress } from '@mui/material';

const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative',
    background: '#FF5F1F',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  root: {
    backgroundColor: 'red',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade direction="up" ref={ref} {...props} />;
});

const BillingInfo = ({
  profileDetails,
  loadProfile,
  profileDetailsLoading,
  loadPrimaryCard,
  primaryCard,
  primaryCardLoading,
  loadBillingUrl,
  billingUrl,
  editExistingCreditCard,
  makePayment,
  ispaymentLoading,
  isPaymentSuccess,
  paymentDetails,
  paymentReset,
  updatedCardDetails,
  updatedCardLoading,
  isPrimaryCardFailed,
  saveCreditCardInfo,
  isAddCardLoading,
  newCardInfo,
}) => {
  const isMobile = useContext(MobileContext);
  const mobClassName = isMobile ? styles.mob : null;
  const [cardInfo, setCardInfo] = useState({});
  const [Gatewayopen, setGatewayOpen] = useState(false);
  const [openPaymentModal, setOpenPaymentModal] = useState(false);
  const [cardLoading, setCardLoading] = useState(true);
  const [buttonStyle, setButtonStyle] = useState(false);
  const [paymentSuccessModal, setPaymentSuccessModal] = useState(false);
  const [initialValue, setInitialValue] = useState(false);
  const [nicknamePopup, setNicknamePopup] = useState(false);
  const [nickName, setNickName] = useState('');
  const classes = useStyles();
  const boxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    padding: '15px 15px 0px 15px',
    boxShadow: 24,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: !isMobile ? '12px' : '15px',
    height: !isMobile ? '180px' : '190px',
    width: !isMobile ? '200px' : '230px',
  };
  const finalBoxStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    padding: '15px 15px 0px 15px',
    boxShadow: 24,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: !isMobile ? '12px' : '15px',
    height: !isMobile ? '100px' : '120px',
    width: !isMobile ? '200px' : '230px',
  };
  const handleClose = () => setGatewayOpen(false);
  const handleClosePaymentModal = () => setOpenPaymentModal(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    paymentReset();
    loadPrimaryCard();
    loadProfile();
    setInitialValue(true);
  }, []);

  function assignListeners() {
    window.addEventListener(
      'message',
      function listener(event) {
        if (event.origin !== process.env.REACT_APP_CLUB_AUTOMATION_URL) {
          return;
        }
        const {
          data: {
            cc_number,
            expiration_year,
            expiration_month,
            cardConnect_expiry,
            cc_merchant_unique_id,
            expiration_date,
            i4go_cardtype,
          },
        } = event;
        if (!isEmpty(cc_merchant_unique_id)) {
          window.messageReceived = true;
          setCardInfo({
            cc_number,
            expiration_year,
            expiration_month,
            cardConnect_expiry,
            cc_merchant_unique_id,
            expiration_date,
            i4go_cardtype,
          });
        }
      },
      false
    );
  }

  const handleUpdateCard = async () => {
    setGatewayOpen(true);
    loadBillingUrl();
    assignListeners();
  };

  const handlePayNow = () => {
    setOpenPaymentModal(true);
  };

  const handleNickname = e => {
    setNickName(e.target.value);
  };

  const handleCancelClick = () => {
    setNicknamePopup(false);
    setGatewayOpen(false);
  };

  const handleAddCard = () => {
    const data = {
      userId: profileDetails?.userID,
      maskedCardNumber: cardInfo.cc_number,
      availableOnPOS: true,
      useContactAddress: true,
      billingName: profileDetails?.name,
      nickname: nickName,
      isPrimary: true,
      i4goUniqueId: cardInfo.cc_merchant_unique_id,
      cardExpirationMonth: cardInfo.expiration_month,
      cardExpirationYear: cardInfo.expiration_year,
    };
    saveCreditCardInfo(data);
    setGatewayOpen(false);
  };

  const submitInfo = () => {
    const data = {
      isPrimary: true,
      availableOnPOS: true,
      billingName: primaryCard?.cardHolderName,
      maskedCardNumber: cardInfo.cc_number,
      cardExpirationMonth: cardInfo.expiration_month,
      i4goUniqueId: cardInfo.cc_merchant_unique_id,
      useContactAddress: true,
      nickname: primaryCard?.cardNickname,
      cardExpirationYear: cardInfo.expiration_year,
      cardId:
        Object.keys(updatedCardDetails).length !== 0
          ? `${updatedCardDetails?.id}`
          : `${primaryCard?.id}`,
      userId: profileDetails?.userID,
    };
    editExistingCreditCard(data);
    setGatewayOpen(false);
    setCardLoading(false);
  };

  useEffect(() => {
    if (Object.keys(updatedCardDetails).length !== 0) {
      setCardInfo({});
    } else if (Object.keys(newCardInfo).length !== 0 && newCardInfo?.success) {
      setNicknamePopup(false);
      setCardInfo({});
      loadPrimaryCard();
    }
  }, [updatedCardDetails, newCardInfo]);

  useEffect(() => {
    if (isPrimaryCardFailed && Object.keys(cardInfo).length !== 0) {
      setNicknamePopup(true);
    } else if (!isPrimaryCardFailed && Object.keys(cardInfo).length !== 0) {
      submitInfo();
    }
  }, [cardInfo]);

  const handleConfirmPayment = () => {
    const paymentID =
      Object.keys(updatedCardDetails).length !== 0
        ? updatedCardDetails?.id
        : primaryCard?.id;
    const data = {
      paymentMethodId: `${paymentID}`,
      paymentAmount: parseFloat(profileDetails?.amountDue.replace(/[^\d.]/g, '')),
      paymentType: 'Credit Card',
    };
    makePayment(data);
    setOpenPaymentModal(false);
  };

  useEffect(() => {
    if (isPaymentSuccess && initialValue) {
      setButtonStyle(true);
      setPaymentSuccessModal(true);
    }
  }, [isPaymentSuccess]);

  const handleFinalClick = () => {
    setPaymentSuccessModal(false);
  };
  return (
    <>
      <div
        className={`${nicknamePopup ? styles.newContainer : styles.body} ${mobClassName}`}
      >
        {nicknamePopup ? (
          <div className={styles.nameContainer}>
            <Text className={styles.nameHeading}>Add Your Card Nickname</Text>
            <input
              type="text"
              className={styles.input}
              value={nickName}
              onChange={handleNickname}
            />
            <div className={!isMobile ? styles.nameWrapper : styles.footer}>
              <div className={styles.buttonContainer}>
                <button className={styles.cancelButton} onClick={handleCancelClick}>
                  Cancel
                </button>
                <button
                  className={
                    nickName.trim() === '' || isAddCardLoading
                      ? styles.disabledSaveButton
                      : styles.saveButton
                  }
                  disabled={nickName.trim() === '' || isAddCardLoading}
                  onClick={handleAddCard}
                >
                  {isAddCardLoading ? (
                    <CircularProgress
                      size={25}
                      style={{ color: '#fe5000', marginTop: '5px' }}
                    />
                  ) : (
                    'Save'
                  )}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <>
            <Text className={styles.heading}>Billing Information</Text>
            <div
              className={`${
                (primaryCardLoading && cardLoading && isMobile) || updatedCardLoading
                  ? styles.spinner
                  : styles.wrapper
              }`}
            >
              <div
                className={
                  (primaryCardLoading && cardLoading) || updatedCardLoading
                    ? styles.loaderWrapper
                    : styles.inputWrapper
                }
              >
                {(primaryCardLoading && cardLoading) || updatedCardLoading ? (
                  <CircularProgress size={50} style={{ color: '#fe5000' }} />
                ) : (
                  <>
                    <h1 className={`${styles.subHeading} ${isMobile ? styles.mob : ''}`}>
                      My Card On File
                    </h1>
                    {isPrimaryCardFailed ? (
                      <div className={styles.noCard}>
                        <div className={styles.buttonWrapper}>
                          <button
                            className={styles.editButton}
                            onClick={handleUpdateCard}
                          >
                            Add Card
                          </button>
                        </div>
                        <p className={styles.noCardText}>No credit card on file</p>
                      </div>
                    ) : (
                      <div className={styles.card}>
                        <div className={styles.titleWrapper}>
                          <img
                            className={styles.cardLogo}
                            src={
                              Object.keys(updatedCardDetails).length !== 0 &&
                              updatedCardDetails?.type
                                ? updatedCardDetails?.type === 'visa'
                                  ? imgVisa
                                  : updatedCardDetails?.type === 'amex'
                                  ? imgAmex
                                  : updatedCardDetails?.type === 'mastercard'
                                  ? imgMastercard
                                  : imgDiscover
                                : primaryCard?.type === 'visa'
                                ? imgVisa
                                : primaryCard?.type === 'amex'
                                ? imgAmex
                                : primaryCard?.type === 'mastercard'
                                ? imgMastercard
                                : imgDiscover
                            }
                          />
                          <button
                            className={styles.editButton}
                            onClick={handleUpdateCard}
                          >
                            Update Card
                          </button>
                        </div>
                        <div className={styles.cardDetailsWrapper}>
                          <p className={styles.cardName}>{primaryCard?.cardHolderName}</p>
                          <p className={styles.cardNumber}>
                            {`**** **** **** ${(Object.keys(updatedCardDetails).length !==
                              0 &&
                              updatedCardDetails?.lastFourDigits?.slice(-4)) ||
                              primaryCard?.lastFourDigits?.slice(-4)}`}
                          </p>
                          <p className={styles.cardExpiry}>
                            Exp:{' '}
                            <span>
                              {Object.keys(updatedCardDetails).length !== 0
                                ? updatedCardDetails?.expiration
                                : primaryCard?.expiration}
                            </span>
                          </p>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className={styles.divider} />
            <div className={styles.belowWrapper}>
              <div
                className={
                  primaryCardLoading && cardLoading
                    ? styles.loading
                    : styles.amountCardWrapper
                }
              >
                {primaryCardLoading && cardLoading ? (
                  <CircularProgress size={50} style={{ color: '#fe5000' }} />
                ) : (
                  <>
                    {(ispaymentLoading || profileDetailsLoading) && (
                      <CircularProgress
                        size={50}
                        style={{ color: '#fe5000' }}
                        className={`${
                          ispaymentLoading || profileDetailsLoading ? styles.loader : ''
                        }`}
                      />
                    )}
                    <div className={styles.amountCard}>
                      <div className={styles.belowCardWrapper}>
                        <div className={styles.amountWrapper}>
                          <p
                            className={`${
                              !ispaymentLoading
                                ? styles.amountText
                                : styles.amountLoadingText
                            }`}
                          >
                            Balance
                          </p>
                          <p
                            className={`${
                              profileDetails?.isCredit
                                ? styles.amountCreditNumber
                                : !ispaymentLoading
                                ? styles.amountNumber
                                : styles.amountLoadingNumber
                            }`}
                          >
                            {Object.keys(paymentDetails).length !== 0
                              ? paymentDetails?.dueAmount
                              : profileDetails && profileDetails?.isCredit
                              ? `(${profileDetails?.amountDue})`
                              : profileDetails?.amountDue}
                          </p>
                        </div>
                        <Button
                          width={'auto'}
                          className={`${
                            !buttonStyle &&
                            !profileDetails?.isCredit &&
                            profileDetails?.amountDue !== '$0.00'
                              ? styles.button
                              : styles.finalButton
                          }`}
                          disabled={
                            ispaymentLoading ||
                            profileDetailsLoading ||
                            profileDetails?.isCredit ||
                            profileDetails?.amountDue === '$0.00' ||
                            (Object.keys(paymentDetails).length !== 0 &&
                              paymentDetails?.dueAmount === '$0.00')
                          }
                          onClick={handlePayNow}
                        >
                          Pay Now
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <Dialog
              fullScreen
              open={Gatewayopen}
              onClose={handleClose}
              TransitionComponent={Transition}
            >
              <AppBar position="fixed">
                <Toolbar variant="dense">
                  <IconButton
                    edge="start"
                    color="inherit"
                    onClick={handleClose}
                    aria-label="menu"
                    sx={{ mr: 2 }}
                  >
                    <CloseIcon />
                  </IconButton>
                  <Typography variant="h6" color="inherit" component="div">
                    {isPrimaryCardFailed ? 'Add New Card' : 'Update Card'}
                  </Typography>
                </Toolbar>
              </AppBar>
              {billingUrl ? (
                <iframe
                  title="payment"
                  id="payment"
                  src={`${billingUrl?.data}&parentUrl=${window.location.href}`}
                  width="700px"
                  style={{
                    display: 'block',
                    alignSelf: 'center',
                    overflow: 'hidden',
                    position: 'relative',
                    marginLeft: '-20px',
                    marginTop: '40px',
                  }}
                  scrolling="no"
                  height={document.documentElement.clientHeight - 50}
                />
              ) : (
                <div className={classes.root}>
                  <Box sx={{ width: '100%' }}>
                    <LinearProgress color="secondary" />
                  </Box>
                </div>
              )}
            </Dialog>
            <Modal open={openPaymentModal} onClose={handleClosePaymentModal}>
              <Box sx={boxStyle}>
                <div className={styles.iconWrapper}>
                  <img
                    alt="logo"
                    src={closeIcon}
                    onClick={handleClosePaymentModal}
                    className={styles.logo}
                  />
                </div>
                {!isMobile ? (
                  <Text className={styles.imgHeading}>
                    You're about to make <br /> a payment of
                  </Text>
                ) : (
                  <Text className={styles.imgHeading}>
                    You're about to make a <br /> payment of
                  </Text>
                )}
                <Text className={styles.amountTotal}>{profileDetails?.amountDue}</Text>
                <button className={styles.paymentButton} onClick={handleConfirmPayment}>
                  Confirm Payment
                </button>
              </Box>
            </Modal>
            <Modal open={paymentSuccessModal}>
              <Box sx={finalBoxStyle}>
                <div className={styles.checkIconWrapper}>
                  <img
                    alt=""
                    src={checkmarkCircleOutline}
                    className={`${styles.checkLogo} ${isMobile ? styles.mob : ''}`}
                  />
                </div>
                <Text className={styles.paymentText}>Payment Confirmed!</Text>
                <p className={styles.paymentLink} onClick={handleFinalClick}>
                  Go to Billing Information
                </p>
              </Box>
            </Modal>
          </>
        )}
      </div>
    </>
  );
};

export default BillingInfo;
